<template>
    <!-- Accommodation and Category -->
    <v-row v-if="serviceType !== contractServiceType.ownExtraService" dense>
        <v-col cols="12" sm="6" md="4">
            <v-autocomplete
                v-model="modelValue.otaCode"
                :items="useRoomCode"
                :label="`${$t('product_tabs.accommodation')}*`"
                density="compact"
                variant="outlined"
                color="primary"
                data-cy="accommodation"
                :readonly="isFieldReadonly"
                :disabled="isFieldDisabled"
                @update:model-value="emit('update-capacity')"
            />
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-autocomplete
                v-model="modelValue.roomCategoryId"
                :items="categories"
                item-value="id"
                item-title="name"
                :label="`${$t('category')}*`"
                density="compact"
                variant="outlined"
                color="primary"
                data-cy="category-id"
                :disabled="!!modelValue?.id || isFieldDisabled"
                :rules="[requiredRule('category')]"
                :readonly="isFieldReadonly"
            />
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
    import {requiredRule} from '~/composables/rules'
    import {contractServiceType, RoomCode} from '~/utils/types/types'

    const props = defineProps<{
        modelValue: any
        serviceType?: string
        categories: any[]
        isFieldReadonly: boolean
        isFieldDisabled: boolean
    }>()

    const emit = defineEmits<{
        'update:modelValue': [value: any]
        'update-capacity': []
    }>()

    const {t} = useI18n()

    const useRoomCode = computed(() => {
        const roomCodes = ['OTHER', 'SINGLE', 'DOUBLE', 'TRIPLE', 'QUADRUPLE', 'FAMILY']
        return roomCodes.map(value => ({value: RoomCode[value], title: t(`roomCode.${value}`)}))
    })
</script>
